import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthContext } from '@/context/AuthProvider';
import { useUserRole } from '@/hooks/useUserRole';

export const AdminProtectedRoute: FC = () => {
  const { user } = useAuthContext();
  const { canAccessAdmin, isAdvisor } = useUserRole();
  const location = useLocation();

  // Not logged in -> redirect to login
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Logged in but not admin/advisor -> redirect to dashboard
  // canAccessAdmin alone is admin-tier only (see useUserRole) — this route's
  // own comment and every sibling guard (e.g. HomeHQProtectedRoute) already
  // treat advisor as equally entitled, so it must be OR'd in explicitly here too.
  if (!canAccessAdmin && !isAdvisor) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
